import { types } from "mobx-state-tree"

const UltimateCategory = types.model('UltimateCategory', {
    id: types.identifierNumber,
    name: types.string,
})

export default UltimateCategory
